import { SxProps } from '@mui/system';

type ThemeType = {
	light: string;
	default: string;
};

export interface ChatTheme {
	timeBar: ThemeType;
	recv: ThemeType;
	sent: ThemeType;
	del: ThemeType;
	star: ThemeType;
	anon: ThemeType;
	system: ThemeType;
}

export const kikTheme: ChatTheme = {
	timeBar: {
		light: '#ccccff',
		default: '#71719b',
	},
	recv: {
		light: '#e5ebef',
		default: '#696f72',
	},
	sent: {
		light: '#3dc03d',
		default: '#2a872a',
	},
	del: {
		light: '#eeaaaa',
		default: '#a66262',
	},
	star: {
		light: '#faf032',
		default: '#797307',
	},
	anon: {
		light: '#32e3fa',
		default: '#157582',
	},
	system: {
		light: '#eeeeee',
		default: '#222222',
	},
};

export const getItemColour = (itemName: keyof ChatTheme, chatTheme: ChatTheme, userTheme: 'light' | 'default'): string => {
	if (userTheme === 'light') {
		return chatTheme[itemName].light;
	} else {
		return chatTheme[itemName].default;
	}
};

const arrowIconBase = {
	content: '""',
	position: 'absolute',
	top: '0px',
	width: '15px',
	height: '15px',
	zIndex: 1,
};

export const leftArrowSx = {
	...arrowIconBase,
	left: '-15px',
	clipPath: 'polygon(0 0, 100% 0, 100% 100%)',
};

export const rightArrowSx = {
	...arrowIconBase,
	right: '-15px',
	clipPath: 'polygon(0 0, 100% 0, 0 100%)',
};

export const watermarkContainerSx: SxProps = {
	position: 'fixed',
	top: 0,
	width: '100%',
	height: '100vh',
	zIndex: 9999,
	display: 'none',
	gridTemplateRows: 'repeat(auto-fill, minmax(600px, 1fr))',
	textAlign: 'center',
	justifyItems: 'center',
	alignItems: 'center',
	'@media print': {
		display: 'grid',
	},
};

export const watermarkTextSx: SxProps = {
	opacity: '30%',
	fontSize: '72px',
	transform: 'rotate(45deg)',
	color: 'red',
	whiteSpace: 'pre-wrap',
};
